import { render, staticRenderFns } from "./ButtonField.vue?vue&type=template&id=47a4d156&scoped=true&"
import script from "./ButtonField.vue?vue&type=script&lang=js&"
export * from "./ButtonField.vue?vue&type=script&lang=js&"
import style0 from "./ButtonField.vue?vue&type=style&index=0&id=47a4d156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4d156",
  null
  
)

export default component.exports